/**
 * Returns `true` when the `VITE_SKIP_FUNNEL_AUTH=1` env var is set,
 * allowing local dev to bypass the Kinde auth redirect.
 */
export const isSkipAuthEnabled = (): boolean => {
  const meta = import.meta as unknown as { env?: Record<string, string | undefined> };
  return meta.env?.VITE_SKIP_FUNNEL_AUTH === "1";
};
